import React, { useState } from "react";
import { Button, TextField, Grid, CircularProgress } from "@material-ui/core";
import PropTypes from "prop-types";

import { useStyles } from "./styles";
import { Validation } from "../../../resources/validation";

export default function StateInput(props) {
  const [postalCode, setPostalCode] = useState("");
  const [error, setError] = React.useState("");
  const classes = useStyles();

  const handleChange = event => {
    if (event.target.value === "") {
      setError("This field can not be empty");
    } else {
      if (!Validation.number(event.target.value)) {
        setError("Postcode shoud be a number");
      }
      if (Validation.number(event.target.value) && event.target.value.length < 5) {
        setPostalCode(event.target.value);
        setError("");
      }
    }
  };

  const onSubmit = e => {
    e.preventDefault();
    if (postalCode.length !== 4) {
      setError("Postcode shoud be 4 digits number");
    } else {
      props.setPostal(postalCode);
    }
  };

  return (
    <Grid className={classes.root} container direction="column" justifyContent="center" alignItems="stretch">
      <form id="form" onSubmit={onSubmit}>
        <Grid item>
          <TextField
            autoComplete="on"
            className={classes.postalDisplay}
            error={error !== ""}
            helperText={error}
            value={postalCode}
            onChange={handleChange}
            required
            type="num"
            name="postalcode"
            id="postalcode"
            label="Your postcode"
            margin="normal"
            variant="outlined"
            color="secondary"
          />
        </Grid>
        <Grid item>
          <Button type="submit" variant="contained" className={classes.postalConfirm} >
            continue sizing my system{props.stateFetching && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Button>
        </Grid>
      </form>
    </Grid>
  );
}

StateInput.propTypes = {
  setPostal: PropTypes.func,
  stateFetching: PropTypes.bool
};
